import { createSlice } from '@reduxjs/toolkit';
import { sendHL7Api } from '../../../rtk-apis/hl7/sendHL7';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const sendHL7Slice = createSlice({
  name: 'sendHL7',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(sendHL7Api.pending, state => {
        state.loading = true;
      })
      .addCase(sendHL7Api.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || 'Sent successfully';
      })
      .addCase(sendHL7Api.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Send failed';
      });
  },
});

export const { clearState: clearSendHL7State } = sendHL7Slice.actions;
export default sendHL7Slice.reducer;
